import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IllustrationBackgroundReminders = function IllustrationBackgroundReminders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 417 359"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "m332.595 78.096-.007-.033.02.033z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M289.361 14.731s12.32.02 15.623.749l-4.783 4.799s-2.973-.81-11.454.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "M292.361 27.47s-3.439-9.57-3-12.739l-6.754 6.918s.788 5.56 3.697 12.024zm7.872-7.051s-.219-8.321-3.787-16.101L302.909 0s4.234 9.859 3.769 16.034z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M153.061 108.301s-1.5-15.005-1.073-19.116l6.056 5.233s-.556 3.723 1.551 13.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "M167.19 103.081s-10.471 5.36-14.136 5.22l8.713 7.372s6.231-1.644 13.231-5.982zm-9.004-8.716s-9.45 1.29-17.865 6.597l-5.714-7.339s10.704-6.37 17.788-6.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4F74",
    d: "m404.142 267.994-6.535 12.679 13.14-.388.55-7.058z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "m152.607 32.64 4.356 10.694 7.783 2.339-1.616-9.197zm24 126 4.356 10.694 7.783 2.339-1.616-9.197z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m169.984 199.945 1.437 11.456 6.911 4.272.822-9.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M155.102 328.129s-14.394-2.46-18.117-3.963l6.476-4.666s3.322 1.538 13.399 2.126z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "M153.958 312.656s2.243 11.857 1.144 15.473l9.172-6.744s.11-6.65-2.094-14.778zm-10.51 6.684s-1.286 9.765 1.448 19.563l-8.351 3.77s-3.122-12.352-1.441-19.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M401.456 119.061s3.95 6.01 4.659 7.855l-3.861-.764s-.561-1.713-3.736-5.539z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "M396.257 124.673s3.525-4.793 5.199-5.612l-5.516-1.036s-2.437 2.195-4.629 5.72zm5.944 1.537s3.956-2.818 6.573-7.096l4.167 1.741s-3.408 5.275-6.544 7.064z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "m133.312 192.172 13.847-9.853-7.467-8.603-6.022 7.609z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4F74",
    d: "m178.901 338.566-6.535 12.686 7.323-.395.543-7.051zM402.859 66.462l5.392 13.211 4.465-5.811-5.007-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "m164.607 260.984 14.608 8.689 4.873-10.293-9.398-2.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m309.607 77.73 11.236-2.709 3.476-7.337-9.345.224zm106.197-49.49-6.477-6.271-7.72 2.537 6.6 6.612z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M411.218 207.755s-9.736-5.267-12.641-6.144l1.826 5.578s2.679.68 8.993 4.997z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "M403.678 215.826s6.599-5.558 7.544-8.075l2.52 7.978s-2.88 3.745-7.803 7.247zm-3.353-8.556s3.554-6.022 9.534-10.206l-3.348-5.942s-7.349 5.43-9.495 10.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M297.939 180.647s8.629 6.932 11.328 8.317l-.791-5.815s-2.513-1.15-7.946-6.533z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "M306.811 174.065s-7.493 4.28-8.876 6.586l-1.042-8.302s3.508-3.166 8.982-5.725zm1.756 9.018s-4.581 5.284-11.218 8.324l2.224 6.448s8.207-4.02 11.17-8.288z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "m348.95 198.034-10.706 4.351-2.342 7.773 9.207-1.614zm21.152-150.905s-14.394-2.46-18.117-3.963l6.476-4.666s3.322 1.538 13.399 2.126z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "M368.958 31.656s2.243 11.857 1.144 15.473l9.172-6.744s.11-6.65-2.094-14.778zm-10.51 6.684s-1.286 9.765 1.448 19.563l-8.351 3.77s-3.122-12.352-1.441-19.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "m339.607 113.984 14.608 8.689 4.873-10.293-9.398-2.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m377.607 152.71 5.443 10.185 7.983 1.521-2.562-8.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "m332.595 78.096-.007-.033.02.033z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M289.361 14.731s12.32.02 15.623.749l-4.783 4.799s-2.973-.81-11.454.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "M292.361 27.47s-3.439-9.57-3-12.739l-6.754 6.918s.788 5.56 3.697 12.024zm7.872-7.051s-.219-8.321-3.787-16.101L302.909 0s4.234 9.859 3.769 16.034z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M153.061 108.301s-1.5-15.005-1.073-19.116l6.056 5.233s-.556 3.723 1.551 13.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "M167.19 103.081s-10.471 5.36-14.136 5.22l8.713 7.372s6.231-1.644 13.231-5.982zm-9.004-8.716s-9.45 1.29-17.865 6.597l-5.714-7.339s10.704-6.37 17.788-6.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4F74",
    d: "m404.142 267.994-6.535 12.679 13.14-.388.55-7.058z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "m152.607 32.64 4.356 10.694 7.783 2.339-1.616-9.197zm24 126 4.356 10.694 7.783 2.339-1.616-9.197z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m169.984 199.945 1.437 11.456 6.911 4.272.822-9.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M155.102 328.129s-14.394-2.46-18.117-3.963l6.476-4.666s3.322 1.538 13.399 2.126z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "M153.958 312.656s2.243 11.857 1.144 15.473l9.172-6.744s.11-6.65-2.094-14.778zm-10.51 6.684s-1.286 9.765 1.448 19.563l-8.351 3.77s-3.122-12.352-1.441-19.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M401.456 119.061s3.95 6.01 4.659 7.855l-3.861-.764s-.561-1.713-3.736-5.539z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "M396.257 124.673s3.525-4.793 5.199-5.612l-5.516-1.036s-2.437 2.195-4.629 5.72zm5.944 1.537s3.956-2.818 6.573-7.096l4.167 1.741s-3.408 5.275-6.544 7.064z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "m133.312 192.172 13.847-9.853-7.467-8.603-6.022 7.609z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4F74",
    d: "m178.901 338.566-6.535 12.686 7.323-.395.543-7.051zM402.859 66.462l5.392 13.211 4.465-5.811-5.007-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "m164.607 260.984 14.608 8.689 4.873-10.293-9.398-2.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m309.607 77.73 11.236-2.709 3.476-7.337-9.345.224zm106.197-49.49-6.477-6.271-7.72 2.537 6.6 6.612z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M411.218 207.755s-9.736-5.267-12.641-6.144l1.826 5.578s2.679.68 8.993 4.997z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "M403.678 215.826s6.599-5.558 7.544-8.075l2.52 7.978s-2.88 3.745-7.803 7.247zm-3.353-8.556s3.554-6.022 9.534-10.206l-3.348-5.942s-7.349 5.43-9.495 10.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M297.939 180.647s8.629 6.932 11.328 8.317l-.791-5.815s-2.513-1.15-7.946-6.533z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "M306.811 174.065s-7.493 4.28-8.876 6.586l-1.042-8.302s3.508-3.166 8.982-5.725zm1.756 9.018s-4.581 5.284-11.218 8.324l2.224 6.448s8.207-4.02 11.17-8.288z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "m348.95 198.034-10.706 4.351-2.342 7.773 9.207-1.614zm21.152-150.905s-14.394-2.46-18.117-3.963l6.476-4.666s3.322 1.538 13.399 2.126z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "M368.958 31.656s2.243 11.857 1.144 15.473l9.172-6.744s.11-6.65-2.094-14.778zm-10.51 6.684s-1.286 9.765 1.448 19.563l-8.351 3.77s-3.122-12.352-1.441-19.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "m339.607 113.984 14.608 8.689 4.873-10.293-9.398-2.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m377.607 152.71 5.443 10.185 7.983 1.521-2.562-8.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M381.456 259.061s3.95 6.01 4.659 7.855l-3.861-.764s-.561-1.713-3.736-5.539z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "M376.257 264.673s3.525-4.793 5.199-5.612l-5.516-1.036s-2.437 2.195-4.629 5.72zm5.944 1.537s3.956-2.818 6.573-7.096l4.167 1.741s-3.408 5.275-6.544 7.064z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M407.218 328.755s-9.736-5.267-12.641-6.144l1.826 5.578s2.679.68 8.993 4.997z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "M399.678 336.826s6.599-5.558 7.544-8.075l2.52 7.978s-2.88 3.745-7.803 7.247zm-3.353-8.556s3.554-6.022 9.534-10.206l-3.348-5.942s-7.349 5.43-9.495 10.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "m319.607 253.984 14.608 8.689 4.873-10.293-9.398-2.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m357.607 292.71 5.443 10.185 7.983 1.521-2.562-8.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M381.456 259.061s3.95 6.01 4.659 7.855l-3.861-.764s-.561-1.713-3.736-5.539z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "M376.257 264.673s3.525-4.793 5.199-5.612l-5.516-1.036s-2.437 2.195-4.629 5.72zm5.944 1.537s3.956-2.818 6.573-7.096l4.167 1.741s-3.408 5.275-6.544 7.064z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M407.218 328.755s-9.736-5.267-12.641-6.144l1.826 5.578s2.679.68 8.993 4.997z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "M399.678 336.826s6.599-5.558 7.544-8.075l2.52 7.978s-2.88 3.745-7.803 7.247zm-3.353-8.556s3.554-6.022 9.534-10.206l-3.348-5.942s-7.349 5.43-9.495 10.162z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "m319.607 253.984 14.608 8.689 4.873-10.293-9.398-2.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m357.607 292.71 5.443 10.185 7.983 1.521-2.562-8.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "m83.62 299.25.006.033-.02-.033z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M328.459 325.115s-12.32-.02-15.623-.749l4.783-4.799s2.974.809 11.454-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "M325.46 312.376s3.438 9.571 2.999 12.739l6.754-6.918s-.788-5.561-3.697-12.024zm-7.873 7.051s.22 8.321 3.788 16.101l-6.464 4.318s-4.234-9.859-3.768-16.034z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M263.153 269.045s1.5 15.005 1.073 19.116l-6.056-5.234s.556-3.722-1.552-13.929z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "M249.024 274.265s10.471-5.36 14.136-5.22l-8.713-7.372s-6.231 1.644-13.231 5.982zm9.004 8.716s9.449-1.29 17.865-6.597l5.714 7.339s-10.704 6.369-17.788 6.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4F74",
    d: "m12.072 109.352 6.535-12.679-13.14.388-.55 7.058z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "m263.607 344.706-4.357-10.694-7.782-2.339 1.616 9.197zM148.316 68s6.6-5.558 7.545-8.075l2.52 7.978s-2.881 3.746-7.804 7.248z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m106.246 23.884 5.442 10.186 7.984 1.52-2.562-8.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "M78.316 108.001s6.6-5.559 7.545-8.076l2.52 7.978s-2.88 3.746-7.804 7.248z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m106.246 23.884 5.442 10.186 7.984 1.52-2.562-8.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M77.097 56.29s-12.32-.02-15.622-.75l4.783-4.798s2.973.809 11.454-.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "M74.098 43.55s3.439 9.571 3 12.74l6.754-6.918s-.789-5.561-3.697-12.025zm-7.872 7.052s.22 8.32 3.787 16.1L63.55 71.02s-4.234-9.858-3.769-16.034z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M11.792.22s1.5 15.005 1.073 19.115l-6.057-5.233s.556-3.723-1.55-13.929z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "M6.666 14.156s9.45-1.29 17.866-6.597l5.714 7.338s-10.704 6.37-17.788 6.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "M12.246 75.88 7.889 65.188l-7.782-2.34 1.616 9.197zm227.361 142.826-4.357-10.694-7.782-2.339 1.616 9.197z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m246.23 177.4-1.437-11.455-6.911-4.272-.822 9.301z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M250.78 67.151s14.394 2.46 18.117 3.964l-6.476 4.665s-3.323-1.537-13.399-2.126z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "M251.924 82.624s-2.243-11.857-1.144-15.473l-9.172 6.744s-.11 6.65 2.094 14.778zm10.51-6.684s1.286-9.765-1.448-19.563l8.351-3.77s3.122 12.352 1.441 19.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M14.758 258.285s-3.95-6.01-4.659-7.856l3.86.765s.562 1.713 3.736 5.539z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "M19.957 252.673s-3.525 4.792-5.2 5.612l5.517 1.036s2.437-2.195 4.629-5.72zm-5.944-1.537s-3.956 2.818-6.574 7.095l-4.167-1.74s3.409-5.275 6.545-7.064z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "m282.902 185.174-13.848 9.853 7.468 8.603 6.022-7.609z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4F74",
    d: "m237.313 38.78 6.535-12.686-7.323.395-.543 7.051zM13.355 310.884l-5.392-13.211-4.465 5.811 5.007 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "m251.607 116.362-14.608-8.689-4.873 10.293 9.398 2.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m106.607 299.616-11.236 2.709-3.476 7.337 9.345-.225zM.41 349.107l6.477 6.27 7.72-2.537-6.6-6.612z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M4.995 169.591s9.737 5.267 12.642 6.143l-1.826-5.577s-2.679-.68-8.993-4.997z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "M12.536 161.52s-6.6 5.558-7.544 8.075l-2.52-7.978s2.88-3.745 7.803-7.248zm3.354 8.556s-3.555 6.022-9.535 10.206l3.348 5.941s7.35-5.429 9.495-10.161z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "M118.275 196.699s-8.629-6.932-11.328-8.317l.791 5.815s2.513 1.15 7.946 6.533z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "M109.403 203.281s7.493-4.28 8.876-6.586l1.042 8.301s-3.509 3.167-8.982 5.726zm-1.756-9.018s4.581-5.284 11.218-8.324l-2.224-6.448s-8.207 4.02-11.17 8.288z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E2549",
    d: "m67.264 179.312 10.706-4.351 2.342-7.773-9.207 1.614zM46.112 330.217s14.394 2.46 18.117 3.963l-6.476 4.666s-3.323-1.538-13.4-2.126z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34519F",
    d: "M47.256 345.69s-2.243-11.857-1.144-15.473l-9.172 6.744s-.11 6.65 2.094 14.778zm10.51-6.684s1.286-9.765-1.448-19.563l8.35-3.77s3.123 12.352 1.442 19.477z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA4E73",
    d: "m76.607 263.362-14.608-8.689-4.873 10.293 9.398 2.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m38.607 224.636-5.443-10.185-7.983-1.521 2.562 8.98z"
  }));
};